export default "__VITE_ASSET__B3ydC1qq__"